/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {injectIntl} from 'react-intl'
import {withRouter} from "react-router"
import {Button, Card, Grid} from '@scuf/common'
import Loader from '../../common/Loader'
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {Routes} from "../../utils/Routes";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import * as AssetActions from './AssetActions'
import TreeSelector from "../../common/TreeSelector";
import {ASSETS_DATA_SET_TYPE} from "./AssetsConst";

class Assets extends React.Component {

    constructor(props) {
        super(props)
        this.assetSelected = this.assetSelected.bind(this)
    }

    componentDidMount() {
        this.fetchAssets()
    }


    fetchAssets() {
        this.props.AssetActions.fetchAssets(ASSETS_DATA_SET_TYPE.SHALLOW)
    }

    isReadOnly() {
        return !userHasActivity(this.props.userProfile, ACTIVITY_TYPES.ASSETS_WRITE)
    }

    assetSelected(assets) {
        const {history} = this.props;

        if(assets[0].indexOf('asset_') !== -1) {
            history.push(Routes.ASSETS_ADMIN + "/" + assets[0].substr('asset_'.length))
        }

    }

    render() {
        const {intl, loading, assets} = this.props

        const hierarchy = assets.map(a => {
            return {
                id: 'asset' + '_' + a.id,
                name: a.name + ((a.status && a.status === 'disabled') ? ' ' + intl.formatMessage({id: 'admin.fleets.asset.disabled'}) : ''),
                selectable: true,
                items: [],
            }
        })
        return (
            <React.Fragment>
                <Loader loading={loading}/>
                <Grid id="fleet-administration">
                    <Grid.Row>
                        <Grid.Column className={"buttonsInRow"}>
                            <div className="admin-fleets-create-buttons-div">
                                <Button
                                    type="primary"
                                    content={intl.formatMessage({id: "admin.asset.create.title"})}
                                    onClick={() => this.props.history.push(Routes.ASSETS_ADMIN+"/new")}
                                    disabled={this.isReadOnly()}
                                    className="mobile-max-width-button"
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Card>
                                <Card.Header >

                                </Card.Header>
                                <Card.Content>
                                    <TreeSelector
                                        singleSelection={true}
                                        subtreeSelection={false}
                                        tree={hierarchy}
                                        asDropdown={false}
                                        initExpandAll={true}
                                        selectionChanged={this.assetSelected}
                                        placeholder={intl.formatMessage({id:"admin.fleets.selector"})}
                                    />
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
        loading: state.assetReducer.loading,
        assets: state.assetReducer.assets,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        AssetActions: bindActionCreators(AssetActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Assets)))

